import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairAddToWaitlistModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "StaffGradFairAddToWaitlistModalContainer" */
      './StaffGradFairAddToWaitlistModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
